import styles from "./MissingField.module.scss";

export const MissingField = () => <div className={styles.missingField} />;
